import { gql } from '@apollo/client';

export interface RoutePlanningOrderSimpleItem {
  stopNumber: number | null;
  trackingNumber: string | null;
  orderId: number | null;
}

export interface ListRoutePlanningOrdersByDspTaskIdResponse {
  listRoutePlanningOrdersByDspTaskId: RoutePlanningOrderSimpleItem[];
}

export interface ListRoutePlanningOrdersByDspTaskIdVariables {
  dspTaskId: number;
}

export const LIST_ROUTE_PLANNING_ORDERS_BY_DSP_TASK_ID = gql`
  query ListRoutePlanningOrdersByDspTaskId($dspTaskId: Long!) {
    listRoutePlanningOrdersByDspTaskId(dspTaskId: $dspTaskId) {
      stopNumber
      trackingNumber
      orderId
    }
  }
`;

